import { Routes, Route } from "react-router-dom";
import TeamsListPage from "./list";
import AddTeamPage from "./add";
import EditTeamPage from "./edit";
import ViewTeamPage from "./view";

function TeamsPage() {
	return (
		<Routes>
			<Route path="/" element={<TeamsListPage />} />
			<Route path="/add" element={<AddTeamPage />} />
			<Route path="/:id" element={<ViewTeamPage />} />
			<Route path="/:id/edit" element={<EditTeamPage />} />
		</Routes>
	);
}

export default TeamsPage;
